import React from 'react';
import { EditorWizardContext } from '../../../hoc/EditorWizard';
import { LocalizationContext } from '../../../hoc/Localization';
import { SettingsContext } from '../../../hoc/Settings';
import StepContainer from '../StepContainer';
import localStyles from './styles.less';
import PriceComponent from './PriceComponent';

const Price = () => {
  const { t } = React.useContext(LocalizationContext);
  const { edited, updateContent, step } = React.useContext(EditorWizardContext);
  const {
    domainSettings: { defaultCurrency },
  } = React.useContext(SettingsContext);
  const periods = [
    {
      title: t('course.details.content.month'),
      value: 'month',
    },
    {
      title: t('course.details.content.course'),
      value: 'course',
    },
    {
      title: t('course.details.content.hour'),
      value: 'hour',
    },
    {
      title: t('course.details.content.per_custom'),
      value: 'custom',
    },
  ];

  const {
    price,
    currency,
    period,
    period_value: periodValue,
    free_course: freeCourse,
    day,
    time,
  } = edited;
  if (freeCourse && price > 0) {
    edited.price = null;
  }
  return (
    <StepContainer
      step={step}
      nextButtonDisabled={(!freeCourse && (!price || !currency || !period)) || !day || !time}
    >
      <PriceComponent
        t={t}
        updateContent={updateContent}
        freeCourse={freeCourse}
        price={price}
        defaultCurrency={defaultCurrency}
        period={period}
        localStyles={localStyles}
        periods={periods}
        periodValue={periodValue}
        day={day}
        time={time}
        schedules={edited.schedules}
        currency={currency}
      />
    </StepContainer>
  );
};

export default Price;
